<template>
    <v-tooltip bottom v-model="showTooltip">
        <template v-slot:activator="{ on }">
            <v-btn @click="copyLink" :block="block" :color="color" dark>
                <v-text-field
                    background-color="gray lighten-2"
                    readonly
                    v-model="url"
                    ref="textToCopy"
                    outlined
                    hide-details
                    class="text-to-copy"
                />
                <v-icon small class="mr-2">far fa-copy</v-icon>
                {{ $t('Copy') }}
            </v-btn>
        </template>

        <span>{{$t('Link copied!')}}</span>
    </v-tooltip>
</template>

<style scoped>
.text-to-copy {
    opacity: 0;
    position: absolute;
    top: -10000px;
}
</style>

<script>
export default {
    name: 'CopyLink',
    props: {
        url: {},
        block: Boolean
    },
    data() {
        return {
            color: '#848484',
            showTooltip: false,
        };
    },
    methods: {
        copyLink() {
            let textToCopy = this.$refs.textToCopy.$el.querySelector('input')
            textToCopy.select()
            document.execCommand('copy');
            this.showTooltip = true;
            setInterval(() => this.showTooltip = false, 2000);
        },
    },
};
</script>